import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["props", "children"],
  _excluded2 = ["displayConfig"];
import { useContext } from 'react';
import { FullPageLoader } from './FullPageLoader';
import { FullPageDisplay } from './FullPageDisplay';
import { AccessCheckAccessInfoContext } from '../../../../contexts/AccessCheckAccessInfoContext';
import { AccessInfoRetriever } from '../../../internal/Shared/AccessInfoRetriever';
import { hasAllGates } from '../../../../utils/gatesCheckUtil';
import { enrichRequestAccessConfig } from '../../../../utils/enrichRequestAccessConfig';
import { jsx as _jsx } from "react/jsx-runtime";
function AccessCheckFullPageContextWrapper(_ref) {
  let {
      props,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    taskDescription = ''
  } = props;
  const accessInfo = useContext(AccessCheckAccessInfoContext);
  const requestAccessConfig = enrichRequestAccessConfig(props);
  if (accessInfo.hasAccess) {
    return children;
  }
  if (!accessInfo.isVisible) {
    return null;
  }
  if (accessInfo.isLoading) {
    return /*#__PURE__*/_jsx(FullPageLoader, {});
  }
  return /*#__PURE__*/_jsx(FullPageDisplay, Object.assign({
    taskDescription: taskDescription,
    requestAccessConfig: requestAccessConfig
  }, rest));
}
export function AccessCheckFullPageWrapper({
  props,
  children
}) {
  var _props$gates;
  const {
      displayConfig
    } = props,
    requestProps = _objectWithoutPropertiesLoose(props, _excluded2);
  if (!hasAllGates((_props$gates = props.gates) !== null && _props$gates !== void 0 ? _props$gates : [])) {
    return children;
  }
  return /*#__PURE__*/_jsx(AccessInfoRetriever, {
    config: requestProps,
    children: /*#__PURE__*/_jsx(AccessCheckFullPageContextWrapper, Object.assign({
      props: requestProps
    }, Object.assign({}, displayConfig === null || displayConfig === void 0 ? void 0 : displayConfig.domProps, displayConfig === null || displayConfig === void 0 ? void 0 : displayConfig.tokenProps), {
      children: children
    }))
  });
}
AccessCheckFullPageWrapper.displayName = 'AccessCheckFullPageWrapper';